import { ServiceResponse } from "@sdbn/appclient";

export enum ParamterType {
    NONE = 'NONE', STRING = 'STRING', NUMBER = 'NUMBER'
}

export class SupplementaryEquipment {
    key: string;
    dictionaryKey: string;
    selected: boolean;
    handouted = false;
    parameter1DictionaryKey: string;
    parameter1Type: ParamterType;
    parameter1Value: string;

    constructor(equipment?: any) {
        if (equipment != null) {
            this.key = equipment.key;
            this.dictionaryKey = equipment.dictionaryKey;
            this.selected = equipment.selected;
            this.handouted = equipment.handouted;
            this.parameter1DictionaryKey = equipment.parameter1DictionaryKey;
            this.parameter1Type = equipment.parameter1Type;
            this.parameter1Value = equipment.parameter1Value;
        }
    }
}

export class SupplementaryEquipmentResponse extends ServiceResponse {

    equipments: SupplementaryEquipment[];
}


export class TruckDetails {

    id: number;
    registration: string;
    leave: string;
    numberPlate: string;
    driver: string;
    coDriver: string;
    carrier: string;
    supplier: string;
    useGlobalConnect = false;
    usePager = false;
    serviceTruck: boolean;
    includedInTruckGroups: boolean;

    equipment = new Array<SupplementaryEquipment>();

    constructor(truck?: any) {
        if (truck != null) {
            this.id = truck.id;
            this.registration = truck.registration;
            this.leave = truck.leave;
            this.numberPlate = truck.numberPlate;
            this.driver = truck.driver;
            this.coDriver = truck.coDriver;
            this.carrier = truck.carrier;
            this.supplier = truck.supplier;
            this.useGlobalConnect = truck.useGlobalConnect;
            this.usePager = truck.usePager;
            this.serviceTruck = truck.serviceTruck;
            this.includedInTruckGroups = truck.includedInTruckGroups;
            if (truck.equipment != null) {
                for (const e of truck.equipment) {
                    this.equipment.push(new SupplementaryEquipment(e));
                }
            }
        }
    }
}
